function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesMicrowaveFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5a2 2 0 00-2 2v16a2 2 0 002 2h24a2 2 0 002-2V7a2 2 0 00-2-2H4zm24 2H4v16h24V7z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11H8v8h10v-8zM8 9a2 2 0 00-2 2v8a2 2 0 002 2h10a2 2 0 002-2v-8a2 2 0 00-2-2H8z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 25h4v2H6v-2zM22 25h4v2h-4v-2zM26 17a2 2 0 11-4 0 2 2 0 014 0zM22 10h4v3h-4v-3z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesMicrowaveFilled;